import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorCurrencyField } from '@components/common/CalculatorCurrencyField/CalculatorCurrencyField';
import { payeEmployedQuestions } from './questions';
import { PayeEmployedFieldsProps } from './types';
import { useFormContext } from 'react-hook-form';
import { getValidatePeriodFunc } from '../../../../common/helpers';

export const PayeEmployedFields: FC<PayeEmployedFieldsProps> = ({ applicantNumber, incomeType }) => {
  const intl = useIntl();
  const { watch } = useFormContext();

  const { basicAnnualSalary, bonus, commission, overtime, guaranteedEmployeeBenefits, error } = payeEmployedQuestions;
  const errorMessage = intl.formatMessage({ id: error.required });

  const basicAnnualSalaryName = basicAnnualSalary.getFieldName(applicantNumber, incomeType);
  const bonusName = bonus.getFieldName(applicantNumber, incomeType);
  const commissionName = commission.getFieldName(applicantNumber, incomeType);
  const overtimeName = overtime.getFieldName(applicantNumber, incomeType);
  const guaranteedEmployeeBenefitsName = guaranteedEmployeeBenefits.getFieldName(applicantNumber, incomeType);

  const bonusValue = watch(bonusName);
  const commissionValue = watch(commissionName);
  const overtimeValue = watch(overtimeName);
  const guaranteedEmployeeBenefitsValue = watch(guaranteedEmployeeBenefitsName);

  return (
    <>
      <CalculatorCurrencyField
        name={basicAnnualSalaryName}
        titleKey={basicAnnualSalary.titleKey}
        textKey={basicAnnualSalary.textKey}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        className={'xs:mb-5 md:mb-10'}
      />
      <CalculatorCurrencyField
        name={bonusName}
        titleKey={bonus.titleKey}
        textKey={bonus.textKey}
        periodProps={{
          options: bonus.periodOptions,
          rules: { validate: getValidatePeriodFunc(bonusValue, errorMessage) },
        }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
        textHref={bonus.textHref}
      />
      <CalculatorCurrencyField
        name={commissionName}
        titleKey={commission.titleKey}
        textKey={commission.textKey}
        periodProps={{
          options: commission.periodOptions,
          rules: { validate: getValidatePeriodFunc(commissionValue, errorMessage) },
        }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
        textHref={commission.textHref}
      />
      <CalculatorCurrencyField
        name={overtimeName}
        titleKey={overtime.titleKey}
        textKey={overtime.textKey}
        periodProps={{
          options: overtime.periodOptions,
          rules: { validate: getValidatePeriodFunc(overtimeValue, errorMessage) },
        }}
        className={'xs:mb-5 md:mb-10'}
        isPeriod
        textHref={overtime.textHref}
      />
      <CalculatorCurrencyField
        name={guaranteedEmployeeBenefitsName}
        titleKey={guaranteedEmployeeBenefits.titleKey}
        textKey={guaranteedEmployeeBenefits.textKey}
        periodProps={{
          options: guaranteedEmployeeBenefits.periodOptions,
          rules: {
            validate: getValidatePeriodFunc(guaranteedEmployeeBenefitsValue, errorMessage),
          },
        }}
        className={'xs:mb-6 md:mb-12'}
        isPeriod
        textHref={guaranteedEmployeeBenefits.textHref}
      />
    </>
  );
};
